import React from 'react';
import PropTypes from 'prop-types';

const DashboardColumn = props => {
    return (
        <div className={`col ${props.className ? props.className : ""}`}>
            {props.children}
        </div>
    );
};

DashboardColumn.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default DashboardColumn;